import React, { Component } from 'react'
import { StaticQuery, graphql} from 'gatsby'

import Col from 'react-bootstrap/Col'

import CourseMenuChapter from '../course-menu-chapter'

import '../course-menu.scss'


const ThreedmssCourseMenu = class extends Component {
  render() {
    return (
      <StaticQuery
        query={graphql`
          query {
            allThreedmssCourseMenuJson {
              edges {
                node {
                  class
                  icon
                  title
                  url
                  next_level {
                    title
                    subtitle
                    url
                    section_url
                    student_url
                    next_level {
                      title
                      url
                      class
                      chapter_index
                      section_url
                      next_level {
                        title
                        url
                        auth
                      }
                    }
                  }
                }
              }
            }
          }
        `}
        render={data => (
          <Col
            xs={12}
            // md={4}
            lg={3}
            id="course-menu"
            className="pt-4"
          >
            {data.allThreedmssCourseMenuJson.edges.map((module, index) => {
              return (
                <CourseMenuChapter
                  authenticated={this.props.authenticated}
                  location={this.props.location}
                  module={module}
                  key={`module-${index + 1}`}
                ></CourseMenuChapter>
              )
            })}
          </Col>
        )}
      />
    )
  }
}

export default ThreedmssCourseMenu